import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { CONTAINER_CLASSES } from '@/components/generals/container'

/**
 * Fixed background details shared by every page: faint vertical grid lines
 * that frame the layout, and a light film grain over everything.
 */
export const Atmosphere: FC = (): ReactNode => {
    return (
        <>
            <div aria-hidden='true' className='pointer-events-none fixed inset-0 z-[1]'>
                <div className={cn(CONTAINER_CLASSES, 'grid h-full grid-cols-2 lg:grid-cols-4')}>
                    {[0, 1, 2, 3].map((column) => (
                        <span
                            key={column}
                            className={cn(
                                'block h-full border-l border-white/[0.045]',
                                column === 1 && 'border-r lg:border-r-0',
                                column >= 2 && 'hidden lg:block',
                                column === 3 && 'lg:border-r'
                            )}
                        />
                    ))}
                </div>
            </div>

            <div aria-hidden='true' className='bg-grain pointer-events-none fixed inset-0 z-[70] opacity-[0.05]' />
        </>
    )
}
